import 'unfetch/polyfill/index.js';
import { IPA_URL } from '../utils/config';

export async function getNonce(): Promise<string> {
  const url = `${IPA_URL}/nonce`;
  // try {
  const res = await fetch(url);
  const data = await res.json();
  return data.token;
  // } catch (error) {}
}
